// import React, { useState, useEffect } from 'react';
// import { Pie } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import SuperAdminSearchHistory from './SuperAdminSearchHistory';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const SuperAdminManage = () => {
//   const [adminFormData, setAdminFormData] = useState({
//     fullName: '', email: '', password: ''
//   });
//   const [reassignForm, setReassignForm] = useState({ jobSeekerId: '', newAdminId: '' });
//   const [editJobSeekerForm, setEditJobSeekerForm] = useState(null);
//   const [editSearchHistoryForm, setEditSearchHistoryForm] = useState(null);
//   const [admins, setAdmins] = useState([]);
//   const [activities, setActivities] = useState({ jobSeekers: [], searchHistories: [] });
//   const [attendanceStats, setAttendanceStats] = useState([]);
//   const [adminMetrics, setAdminMetrics] = useState(null);
//   const [adminJobSeekerStats, setAdminJobSeekerStats] = useState([]);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const token = localStorage.getItem('token');

//   // Fetch data
//   useEffect(() => {
//     const fetchActivities = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setActivities(data);
//         } else {
//           setError(data.message || 'Failed to fetch activities');
//         }
//       } catch (err) {
//         setError('Server error while fetching activities');
//       }
//     };

//     const fetchAdmins = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-admins`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setAdmins(data);
//         } else {
//           setError(data.message || 'Failed to fetch admins');
//         }
//       } catch (err) {
//         setError('Server error while fetching admins');
//       }
//     };

//     const fetchAttendanceStats = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/attendance-stats`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setAttendanceStats(data);
//         } else {
//           setError(data.message || 'Failed to fetch attendance stats');
//         }
//       } catch (err) {
//         setError('Server error while fetching attendance stats');
//       }
//     };

//     const fetchAdminJobSeekerStats = async () => {
//       try {
//         const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/admin-jobseeker-stats`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setAdminJobSeekerStats(data);
//         } else {
//           setError(data.message || 'Failed to fetch admin jobseeker stats');
//         }
//       } catch (err) {
//         setError('Server error while fetching admin jobseeker stats');
//       }
//     };

//     if (token) {
//       fetchActivities();
//       fetchAdmins();
//       fetchAttendanceStats();
//       fetchAdminJobSeekerStats();
//     }
//   }, [token]);

//   // Fetch admin metrics
//   const fetchAdminMetrics = async (adminId) => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/admin-metrics/${adminId}`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setAdminMetrics(data);
//       } else {
//         setError(data.message || 'Failed to fetch admin metrics');
//       }
//     } catch (err) {
//       setError('Server error while fetching admin metrics');
//     }
//   };

//   // Handle admin creation
//   const handleCreateAdmin = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/register-admin`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`
//         },
//         body: JSON.stringify(adminFormData)
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSuccess(data.message);
//         setAdminFormData({ fullName: '', email: '', password: '' });
//         const adminsResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-admins`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const adminsData = await adminsResponse.json();
//         if (adminsResponse.ok) {
//           setAdmins(adminsData);
//         }
//       } else {
//         setError(data.message);
//       }
//     } catch (err) {
//       setError('Server error while creating admin');
//     }
//   };

//   // Handle reassign jobseeker
//   const handleReassignJobSeeker = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/reassign-jobseeker/${reassignForm.jobSeekerId}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`
//         },
//         body: JSON.stringify({ newAdminId: reassignForm.newAdminId })
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSuccess(data.message);
//         setReassignForm({ jobSeekerId: '', newAdminId: '' });
//         const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const activitiesData = await activitiesResponse.json();
//         if (activitiesResponse.ok) {
//           setActivities(activitiesData);
//         }
//       } else {
//         setError(data.message);
//       }
//     } catch (err) {
//       setError('Server error while reassigning jobseeker');
//     }
//   };

//   // Handle delete admin
//   const handleDeleteAdmin = async (adminId) => {
//     if (!window.confirm('Are you sure you want to delete this admin?')) return;
//     setError('');
//     setSuccess('');
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/delete-admin/${adminId}`, {
//         method: 'DELETE',
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSuccess(data.message);
//         setAdmins(admins.filter(a => a._id !== adminId));
//         const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const activitiesData = await activitiesResponse.json();
//         if (activitiesResponse.ok) {
//           setActivities(activitiesData);
//         }
//       } else {
//         setError(data.message);
//       }
//     } catch (err) {
//       setError('Server error while deleting admin');
//     }
//   };

//   // Handle edit jobseeker
//   const handleEditJobSeeker = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/edit-jobseeker/${editJobSeekerForm._id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`
//         },
//         body: JSON.stringify(editJobSeekerForm)
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSuccess(data.message);
//         setEditJobSeekerForm(null);
//         const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const activitiesData = await activitiesResponse.json();
//         if (activitiesResponse.ok) {
//           setActivities(activitiesData);
//         }
//       } else {
//         setError(data.message);
//       }
//     } catch (err) {
//       setError('Server error while editing jobseeker');
//     }
//   };

//   // Handle edit search history
//   const handleEditSearchHistory = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/edit-search-history/${editSearchHistoryForm._id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`
//         },
//         body: JSON.stringify({ reason: editSearchHistoryForm.reason })
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSuccess(data.message);
//         setEditSearchHistoryForm(null);
//         const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         const activitiesData = await activitiesResponse.json();
//         if (activitiesResponse.ok) {
//           setActivities(activitiesData);
//         }
//       } else {
//         setError(data.message);
//       }
//     } catch (err) {
//       setError('Server error while editing search history');
//     }
//   };

//   // Pie chart data for admin metrics
//   const pieChartData = adminMetrics ? {
//     labels: ['Daily', 'Weekly', 'Monthly'],
//     datasets: [{
//       data: [adminMetrics.daily.count, adminMetrics.weekly.count, adminMetrics.monthly.count],
//       backgroundColor: ['#F97316', '#374151', '#FFFFFF'],
//       borderColor: '#374151'
//     }]
//   } : null;

//   // Pie chart data for total jobseekers attended by all admins
//   const totalJobSeekerPieChartData = adminJobSeekerStats.length > 0 ? {
//     labels: ['Daily', 'Weekly', 'Monthly'],
//     datasets: [{
//       data: [
//         adminJobSeekerStats.reduce((acc, stat) => acc + stat.daily.count, 0),
//         adminJobSeekerStats.reduce((acc, stat) => acc + stat.weekly.count, 0),
//         adminJobSeekerStats.reduce((acc, stat) => acc + stat.monthly.count, 0)
//       ],
//       backgroundColor: ['#F97316', '#374151', '#FFFFFF'],
//       borderColor: '#374151'
//     }]
//   } : null;

//   return (
//     <div className="p-6 bg-white text-gray-800">
//       {/* Create Admin Section */}
//       <div className="mb-8">
//         <h2 className="text-2xl font-bold text-gray-800 mb-4">Create Admin Account</h2>
//         <form onSubmit={handleCreateAdmin} className="bg-gray-100 p-6 rounded-lg shadow-md">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
//             <input
//               type="text"
//               placeholder="Full Name"
//               value={adminFormData.fullName}
//               onChange={(e) => setAdminFormData({ ...adminFormData, fullName: e.target.value })}
//               className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//               required
//             />
//             <input
//               type="email"
//               placeholder="Email"
//               value={adminFormData.email}
//               onChange={(e) => setAdminFormData({ ...adminFormData, email: e.target.value })}
//               className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//               required
//             />
//             <input
//               type="password"
//               placeholder="Password"
//               value={adminFormData.password}
//               onChange={(e) => setAdminFormData({ ...adminFormData, password: e.target.value })}
//               className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//               required
//             />
//           </div>
//           <button
//             type="submit"
//             className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
//           >
//             Create Admin
//           </button>
//           {success && <p className="mt-2 text-green-600">{success}</p>}
//           {error && <p className="mt-2 text-red-600">{error}</p>}
//         </form>
//       </div>

//       {/* Reassign JobSeeker Section */}
//       <div className="mb-8">
//         <h3 className="text-xl font-semibold text-gray-800 mb-2">Reassign JobSeeker</h3>
//         <form onSubmit={handleReassignJobSeeker} className="bg-gray-100 p-6 rounded-lg shadow-md">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//             <select
//               value={reassignForm.jobSeekerId}
//               onChange={(e) => setReassignForm({ ...reassignForm, jobSeekerId: e.target.value })}
//               className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//               required
//             >
//               <option value="">Select JobSeeker</option>
//               {activities.jobSeekers.map(js => (
//                 <option key={js._id} value={js._id}>
//                   {js.firstName} {js.lastName} ({js.email})
//                 </option>
//               ))}
//             </select>
//             <select
//               value={reassignForm.newAdminId}
//               onChange={(e) => setReassignForm({ ...reassignForm, newAdminId: e.target.value })}
//               className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//               required
//             >
//               <option value="">Select New Admin</option>
//               {admins.map(admin => (
//                 <option key={admin._id} value={admin._id}>
//                   {admin.fullName} ({admin.email})
//                 </option>
//               ))}
//             </select>
//           </div>
//           <button
//             type="submit"
//             className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
//           >
//             Reassign
//           </button>
//         </form>
//       </div>

//       {/* Admins List Section */}
//       <div className="mb-8">
//         <h3 className="text-xl font-semibold text-gray-800 mb-2">Created Admins</h3>
//         <div className="overflow-x-auto">
//           <table className="w-full border-collapse">
//             <thead>
//               <tr className="bg-gray-200">
//                 <th className="p-2 text-left text-gray-700">Full Name</th>
//                 <th className="p-2 text-left text-gray-700">Email</th>
//                 <th className="p-2 text-left text-gray-700">Password</th>
//                 <th className="p-2 text-left text-gray-700">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {admins?.map(admin => (
//                 <tr key={admin._id} className="border-b border-gray-200 hover:bg-gray-50">
//                   <td className="p-2">{admin.fullName}</td>
//                   <td className="p-2">{admin.email}</td>
//                   <td className="p-2 font-mono text-sm break-all">{admin.password}</td>
//                   <td className="p-2">
//                     <button
//                       onClick={() => fetchAdminMetrics(admin._id)}
//                       className="bg-orange-500 text-white px-2 py-1 rounded hover:bg-orange-600 mr-2"
//                     >
//                       View Metrics
//                     </button>
//                     <button
//                       onClick={() => handleDeleteAdmin(admin._id)}
//                       className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {admins?.length === 0 && (
//             <p className="text-gray-600 mt-2">No admins found.</p>
//           )}
//         </div>
//       </div>

//       {/* Edit JobSeeker Section */}
//       {editJobSeekerForm && (
//         <div className="mb-8">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">Edit JobSeeker</h3>
//           <form onSubmit={handleEditJobSeeker} className="bg-gray-100 p-6 rounded-lg shadow-md">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//               <input
//                 type="text"
//                 placeholder="First Name"
//                 value={editJobSeekerForm.firstName}
//                 onChange={(e) => setEditJobSeekerForm({ ...editJobSeekerForm, firstName: e.target.value })}
//                 className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//                 required
//               />
//               <input
//                 type="text"
//                 placeholder="Last Name"
//                 value={editJobSeekerForm.lastName}
//                 onChange={(e) => setEditJobSeekerForm({ ...editJobSeekerForm, lastName: e.target.value })}
//                 className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//                 required
//               />
//               <input
//                 type="email"
//                 placeholder="Email"
//                 value={editJobSeekerForm.email}
//                 onChange={(e) => setEditJobSeekerForm({ ...editJobSeekerForm, email: e.target.value })}
//                 className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
//                 required
//               />
//             </div>
//             <button
//               type="submit"
//               className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
//             >
//               Save Changes
//             </button>
//             <button
//               type="button"
//               onClick={() => setEditJobSeekerForm(null)}
//               className="ml-2 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
//             >
//               Cancel
//             </button>
//           </form>
//         </div>
//       )}

//       {/* Edit Search History Section */}
//       {editSearchHistoryForm && (
//         <div className="mb-8">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">Edit Search History</h3>
//           <form onSubmit={handleEditSearchHistory} className="bg-gray-100 p-6 rounded-lg shadow-md">
//             <div className="mb-4">
//               <input
//                 type="text"
//                 placeholder="Reason"
//                 value={editSearchHistoryForm.reason || ''}
//                 onChange={(e) => setEditSearchHistoryForm({ ...editSearchHistoryForm, reason: e.target.value })}
//                 className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500 w-full"
//               />
//             </div>
//             <button
//               type="submit"
//               className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
//             >
//               Save Changes
//             </button>
//             <button
//               type="button"
//               onClick={() => setEditSearchHistoryForm(null)}
//               className="ml-2 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
//             >
//               Cancel
//             </button>
//           </form>
//         </div>
//       )}

//       {/* Admin Activities Section */}
//       <div>
//         <h2 className="text-2xl font-bold text-gray-800 mb-4">Admin Activities</h2>
        
//         {/* JobSeekers Table */}
//         <div className="mb-8">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">JobSeekers Created</h3>
//           <div className="overflow-x-auto">
//             <table className="w-full border-collapse">
//               <thead>
//                 <tr className="bg-gray-200">
//                   <th className="p-2 text-left text-gray-700">Name</th>
//                   <th className="p-2 text-left text-gray-700">Email</th>
//                   <th className="p-2 text-left text-gray-700">Created By</th>
//                   <th className="p-2 text-left text-gray-700">Jobs Assigned</th>
//                   <th className="p-2 text-left text-gray-700">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {activities.jobSeekers?.map(jobSeeker => (
//                   <tr key={jobSeeker._id} className="border-b border-gray-200 hover:bg-gray-50">
//                     <td className="p-2">{jobSeeker.firstName} {jobSeeker.lastName}</td>
//                     <td className="p-2">{jobSeeker.email}</td>
//                     <td className="p-2">{jobSeeker.createdBy?.fullName} ({jobSeeker.createdBy?.email})</td>
//                     <td className="p-2">{jobSeeker.jobAssignments?.length || 0}</td>
//                     <td className="p-2">
//                       <button
//                         onClick={() => setEditJobSeekerForm({
//                           _id: jobSeeker._id,
//                           firstName: jobSeeker.firstName,
//                           lastName: jobSeeker.lastName,
//                           email: jobSeeker.email
//                         })}
//                         className="bg-orange-500 text-white px-2 py-1 rounded hover:bg-orange-600"
//                       >
//                         Edit
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {activities.jobSeekers?.length === 0 && (
//               <p className="text-gray-600 mt-2">No jobseekers found.</p>
//             )}
//           </div>
//         </div>

//         {/* Search Histories Table */}
//         {/* <div className="mb-8">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">Search Histories</h3>
//           <div className="overflow-x-auto">
//             <table className="w-full border-collapse">
//               <thead>
//                 <tr className="bg-gray-200">
//                   <th className="p-2 text-left text-gray-700">Admin</th>
//                   <th className="p-2 text-left text-gray-700">JobSeeker Email</th>
//                   <th className="p-2 text-left text-gray-700">JobSeeker Name</th>
//                   <th className="p-2 text-left text-gray-700">Own JobSeeker</th>
//                   <th className="p-2 text-left text-gray-700">Reason</th>
//                   <th className="p-2 text-left text-gray-700">Searched At</th>
//                   <th className="p-2 text-left text-gray-700">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {activities.searchHistories?.map(search => (
//                   <tr key={search._id} className="border-b border-gray-200 hover:bg-gray-50">
//                     <td className="p-2">{search.adminId?.fullName} ({search.adminId?.email})</td>
//                     <td className="p-2">{search.jobSeekerEmail}</td>
//                     <td className="p-2">{search.jobSeekerId ? `${search.jobSeekerId.firstName} ${search.jobSeekerId.lastName}` : '-'}</td>
//                     <td className="p-2">{search.isOwnJobSeeker ? 'Yes' : 'No'}</td>
//                     <td className="p-2">{search.reason || '-'}</td>
//                     <td className="p-2">{new Date(search.searchedAt).toLocaleDateString()}</td>
//                     <td className="p-2">
//                       <button
//                         onClick={() => setEditSearchHistoryForm({
//                           _id: search._id,
//                           reason: search.reason
//                         })}
//                         className="bg-orange-500 text-white px-2 py-1 rounded hover:bg-orange-600"
//                       >
//                         Edit
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {activities.searchHistories?.length === 0 && (
//               <p className="text-gray-600 mt-2">No search histories found.</p>
//             )}
//           </div>
//         </div> */}

//         <SuperAdminSearchHistory />

//         {/* Attendance Stats Table */}
//         <div className="mb-8">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">JobSeeker Attendance Stats</h3>
//           <div className="overflow-x-auto">
//             <table className="w-full border-collapse">
//               <thead>
//                 <tr className="bg-gray-200">
//                   <th className="p-2 text-left text-gray-700">Name</th>
//                   <th className="p-2 text-left text-gray-700">Email</th>
//                   <th className="p-2 text-left text-gray-700">Admin</th>
//                   <th className="p-2 text-left text-gray-700">Present</th>
//                   <th className="p-2 text-left text-gray-700">Absent</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {attendanceStats.map(stat => (
//                   <tr key={stat.jobSeekerId} className="border-b border-gray-200 hover:bg-gray-50">
//                     <td className="p-2">{stat.firstName} {stat.lastName}</td>
//                     <td className="p-2">{stat.email}</td>
//                     <td className="p-2">{stat.admin ? `${stat.admin.fullName} (${stat.admin.email})` : 'Unassigned'}</td>
//                     <td className="p-2">{stat.attendance.present}</td>
//                     <td className="p-2">{stat.attendance.absent}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {attendanceStats.length === 0 && (
//               <p className="text-gray-600 mt-2">No attendance stats available.</p>
//             )}
//           </div>
//         </div>

//         {/* Admin Metrics Section */}
//         {adminMetrics && (
//           <div className="mb-8">
//             <h3 className="text-xl font-semibold text-gray-800 mb-2">Admin Activity Metrics</h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <h4 className="text-lg font-semibold text-gray-800 mb-2">JobSeekers Attended</h4>
//                 <table className="w-full border-collapse">
//                   <thead>
//                     <tr className="bg-gray-200">
//                       <th className="p-2 text-left text-gray-700">Period</th>
//                       <th className="p-2 text-left text-gray-700">Count</th>
//                       <th className="p-2 text-left text-gray-700">JobSeekers</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr className="border-b border-gray-200 hover:bg-gray-50">
//                       <td className="p-2">Daily</td>
//                       <td className="p-2">{adminMetrics.daily.count}</td>
//                       <td className="p-2">{adminMetrics.daily.jobSeekers.map(js => js.email).join(', ') || 'None'}</td>
//                     </tr>
//                     <tr className="border-b border-gray-200 hover:bg-gray-50">
//                       <td className="p-2">Weekly</td>
//                       <td className="p-2">{adminMetrics.weekly.count}</td>
//                       <td className="p-2">{adminMetrics.weekly.jobSeekers.map(js => js.email).join(', ') || 'None'}</td>
//                     </tr>
//                     <tr className="border-b border-gray-200 hover:bg-gray-50">
//                       <td className="p-2">Monthly</td>
//                       <td className="p-2">{adminMetrics.monthly.count}</td>
//                       <td className="p-2">{adminMetrics.monthly.jobSeekers.map(js => js.email).join(', ') || 'None'}</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//               <div className="flex justify-center">
//                 <div className="w-full max-w-xs">
//                   <Pie data={pieChartData} options={{ responsive: true, maintainAspectRatio: false }} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Per-Admin JobSeeker Attendance Stats Section */}
//         <div className="mb-8">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">Per-Admin JobSeeker Attendance Stats</h3>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <h4 className="text-lg font-semibold text-gray-800 mb-2">Attendance Breakdown by Admin</h4>
//               <div className="overflow-x-auto">
//                 <table className="w-full border-collapse">
//                   <thead>
//                     <tr className="bg-gray-200">
//                       <th className="p-2 text-left text-gray-700">Admin</th>
//                       <th className="p-2 text-left text-gray-700">Daily Count</th>
//                       <th className="p-2 text-left text-gray-700">Weekly Count</th>
//                       <th className="p-2 text-left text-gray-700">Monthly Count</th>
//                       <th className="p-2 text-left text-gray-700">JobSeekers (Daily)</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {adminJobSeekerStats.length > 0 ? (
//                       adminJobSeekerStats.map(stat => (
//                         <tr key={stat.admin._id} className="border-b border-gray-200 hover:bg-gray-50">
//                           <td className="p-2">{stat.admin.fullName} ({stat.admin.email})</td>
//                           <td className="p-2">{stat.daily.count}</td>
//                           <td className="p-2">{stat.weekly.count}</td>
//                           <td className="p-2">{stat.monthly.count}</td>
//                           <td className="p-2">{stat.daily.jobSeekers.map(js => js.email).join(', ') || 'None'}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="p-2 text-gray-600 text-center">
//                           No admin jobseeker attendance stats available.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//             <div className="flex justify-center">
//               <div className="w-full max-w-xs">
//                 <h4 className="text-lg font-semibold text-gray-800 mb-2 text-center">Total JobSeekers Attended</h4>
//                 {totalJobSeekerPieChartData ? (
//                   <Pie data={totalJobSeekerPieChartData} options={{ responsive: true, maintainAspectRatio: false }} />
//                 ) : (
//                   <p className="text-gray-600 text-center">No data available for pie chart.</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SuperAdminManage;










import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { toast } from "sonner";
import SuperAdminSearchHistory from "./SuperAdminSearchHistory";

ChartJS.register(ArcElement, Tooltip, Legend);

const SuperAdminManage = () => {
  const [adminFormData, setAdminFormData] = useState({ fullName: "", email: "", password: "", userType: "" });
  const [reassignForm, setReassignForm] = useState({ jobSeekerId: "", newAdminId: "" });
  const [editJobSeekerForm, setEditJobSeekerForm] = useState(null);
  const [editSearchHistoryForm, setEditSearchHistoryForm] = useState(null);
  const [editAccountantForm, setEditAccountantForm] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [accountants, setAccountants] = useState([]);
  const [activities, setActivities] = useState({ jobSeekers: [], searchHistories: [] });
  const [attendanceStats, setAttendanceStats] = useState([]);
  const [adminMetrics, setAdminMetrics] = useState(null);
  const [adminJobSeekerStats, setAdminJobSeekerStats] = useState([]);
  const [employeeBenefits, setEmployeeBenefits] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setActivities(data);
        } else {
          setError(data.message || "Failed to fetch activities");
          toast.error(data.message || "Failed to fetch activities");
        }
      } catch (err) {
        setError("Server error while fetching activities");
        toast.error("Server error while fetching activities");
      }
    };

    const fetchAdmins = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-admins`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setAdmins(data);
        } else {
          setError(data.message || "Failed to fetch admins");
          toast.error(data.message || "Failed to fetch admins");
        }
      } catch (err) {
        setError("Server error while fetching admins");
        toast.error("Server error while fetching admins");
      }
    };

    const fetchAccountants = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/superadmin/all-accountants`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setAccountants(data);
        } else {
          setError(data.message || "Failed to fetch accountants");
          toast.error(data.message || "Failed to fetch accountants");
        }
      } catch (err) {
        setError("Server error while fetching accountants");
        toast.error("Server error while fetching accountants");
      }
    };

    const fetchAttendanceStats = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/attendance-stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setAttendanceStats(data);
        } else {
          setError(data.message || "Failed to fetch attendance stats");
          toast.error(data.message || "Failed to fetch attendance stats");
        }
      } catch (err) {
        setError("Server error while fetching attendance stats");
        toast.error("Server error while fetching attendance stats");
      }
    };

    const fetchAdminJobSeekerStats = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/admin-jobseeker-stats`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setAdminJobSeekerStats(data);
        } else {
          setError(data.message || "Failed to fetch admin jobseeker stats");
          toast.error(data.message || "Failed to fetch admin jobseeker stats");
        }
      } catch (err) {
        setError("Server error while fetching admin jobseeker stats");
        toast.error("Server error while fetching admin jobseeker stats");
      }
    };

    const fetchEmployeeBenefits = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/benefit/get-all-employee-benefits`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (response.ok) {
          setEmployeeBenefits(data.data);
        } else {
          setError(data.message || "Failed to fetch employee benefits");
          toast.error(data.message || "Failed to fetch employee benefits");
        }
      } catch (err) {
        setError("Server error while fetching employee benefits");
        toast.error("Server error while fetching employee benefits");
      }
    };

    if (token) {
      fetchActivities();
      fetchAdmins();
      fetchAccountants();
      fetchAttendanceStats();
      fetchAdminJobSeekerStats();
      fetchEmployeeBenefits();
    }
  }, [token]);

  const fetchAdminMetrics = async (adminId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/admin-metrics/${adminId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) {
        setAdminMetrics(data);
      } else {
        setError(data.message || "Failed to fetch admin metrics");
        toast.error(data.message || "Failed to fetch admin metrics");
      }
    } catch (err) {
      setError("Server error while fetching admin metrics");
      toast.error("Server error while fetching admin metrics");
    }
  };

  const handleCreateAccountant = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const { userType } = adminFormData;
    if (!["adminAccountant1", "adminAccountant2"].includes(userType)) {
      setError("Please select a valid user type (Accountant 1 or Accountant 2)");
      toast.error("Please select a valid user type (Accountant 1 or Accountant 2)");
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/superadmin/register-accountant`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(adminFormData),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setAdminFormData({ fullName: "", email: "", password: "", userType: "" });
        const accountantsResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/superadmin/all-accountants`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const accountantsData = await accountantsResponse.json();
        if (accountantsResponse.ok) {
          setAccountants(accountantsData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while creating accountant");
      toast.error("Server error while creating accountant");
    }
  };

  const handleEditAccountant = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/superadmin/edit-accountant/${editAccountantForm._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          fullName: editAccountantForm.fullName,
          email: editAccountantForm.email,
          password: editAccountantForm.password,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setEditAccountantForm(null);
        const accountantsResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/superadmin/all-accountants`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const accountantsData = await accountantsResponse.json();
        if (accountantsResponse.ok) {
          setAccountants(accountantsData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while editing accountant");
      toast.error("Server error while editing accountant");
    }
  };

  const handleDeleteAccountant = async (accountantId) => {
    if (!window.confirm("Are you sure you want to delete this accountant?")) return;
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/superadmin/delete-accountant/${accountantId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setAccountants(accountants.filter((a) => a._id !== accountantId));
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while deleting accountant");
      toast.error("Server error while deleting accountant");
    }
  };

  const handleFinalBenefitAction = async (benefitId, status, reason) => {
    if (!reason) {
      setError("Reason is required for approval or denial");
      toast.error("Reason is required for approval or denial");
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}superadmin/benefit/${benefitId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status, reason }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        const benefitsResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/accountant/benefit/get-all-employee-benefits`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
        const benefitsData = await benefitsResponse.json();
        if (benefitsResponse.ok) {
          setEmployeeBenefits(benefitsData.data);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while updating benefit");
      toast.error("Server error while updating benefit");
    }
  };

  const handleCreateAdmin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/register-admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(adminFormData),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setAdminFormData({ fullName: "", email: "", password: "", userType: "" });
        const adminsResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-admins`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const adminsData = await adminsResponse.json();
        if (adminsResponse.ok) {
          setAdmins(adminsData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while creating admin");
      toast.error("Server error while creating admin");
    }
  };

  const handleReassignJobSeeker = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/reassign-jobseeker/${reassignForm.jobSeekerId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newAdminId: reassignForm.newAdminId }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setReassignForm({ jobSeekerId: "", newAdminId: "" });
        const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const activitiesData = await activitiesResponse.json();
        if (activitiesResponse.ok) {
          setActivities(activitiesData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while reassigning jobseeker");
      toast.error("Server error while reassigning jobseeker");
    }
  };

  const handleDeleteAdmin = async (adminId) => {
    if (!window.confirm("Are you sure you want to delete this admin?")) return;
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/delete-admin/${adminId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setAdmins(admins.filter((a) => a._id !== adminId));
        const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const activitiesData = await activitiesResponse.json();
        if (activitiesResponse.ok) {
          setActivities(activitiesData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while deleting admin");
      toast.error("Server error while deleting admin");
    }
  };

  const handleEditJobSeeker = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/edit-jobseeker/${editJobSeekerForm._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editJobSeekerForm),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setEditJobSeekerForm(null);
        const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const activitiesData = await activitiesResponse.json();
        if (activitiesResponse.ok) {
          setActivities(activitiesData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while editing jobseeker");
      toast.error("Server error while editing jobseeker");
    }
  };

  const handleEditSearchHistory = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/edit-search-history/${editSearchHistoryForm._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ reason: editSearchHistoryForm.reason }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess(data.message);
        toast.success(data.message);
        setEditSearchHistoryForm(null);
        const activitiesResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/superadmin/all-activities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const activitiesData = await activitiesResponse.json();
        if (activitiesResponse.ok) {
          setActivities(activitiesData);
        }
      } else {
        setError(data.message);
        toast.error(data.message);
      }
    } catch (err) {
      setError("Server error while editing search history");
      toast.error("Server error while editing search history");
    }
  };

  const pieChartData = adminMetrics
    ? {
        labels: ["Daily", "Weekly", "Monthly"],
        datasets: [
          {
            data: [adminMetrics.daily.count, adminMetrics.weekly.count, adminMetrics.monthly.count],
            backgroundColor: ["#16F943FF", "#374151", "#FFFFFF"],
            borderColor: "#374151",
          },
        ],
      }
    : null;

  const totalJobSeekerPieChartData = adminJobSeekerStats.length > 0
    ? {
        labels: ["Daily", "Weekly", "Monthly"],
        datasets: [
          {
            data: [
              adminJobSeekerStats.reduce((acc, stat) => acc + stat.daily.count, 0),
              adminJobSeekerStats.reduce((acc, stat) => acc + stat.weekly.count, 0),
              adminJobSeekerStats.reduce((acc, stat) => acc + stat.monthly.count, 0),
            ],
            backgroundColor: ["#16F969FF", "#374151", "#FFFFFF"],
            borderColor: "#374151",
          },
        ],
      }
    : null;

  return (
    <div className="p-6 bg-white text-gray-800">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Super Admin Dashboard</h2>

      {/* Create Accountant Section */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Create Accountant Account</h3>
        <form onSubmit={handleCreateAccountant} className="bg-gray-100 p-6 rounded-lg shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
            <input
              type="text"
              placeholder="Full Name"
              value={adminFormData.fullName}
              onChange={(e) => setAdminFormData({ ...adminFormData, fullName: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={adminFormData.email}
              onChange={(e) => setAdminFormData({ ...adminFormData, email: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={adminFormData.password}
              onChange={(e) => setAdminFormData({ ...adminFormData, password: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
            <select
              value={adminFormData.userType}
              onChange={(e) => setAdminFormData({ ...adminFormData, userType: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            >
              <option value="" disabled>
                Select User Type
              </option>
              <option value="adminAccountant1">Accountant 1</option>
              <option value="adminAccountant2">Accountant 2</option>
            </select>
          </div>
          <button
            type="submit"
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
          >
            Create Accountant
          </button>
          {success && <p className="mt-2 text-green-600">{success}</p>}
          {error && <p className="mt-2 text-red-600">{error}</p>}
        </form>
      </div>

      {/* Edit Accountant Section */}
      {editAccountantForm && (
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Edit Accountant</h3>
          <form onSubmit={handleEditAccountant} className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <input
                type="text"
                placeholder="Full Name"
                value={editAccountantForm.fullName}
                onChange={(e) => setEditAccountantForm({ ...editAccountantForm, fullName: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={editAccountantForm.email}
                onChange={(e) => setEditAccountantForm({ ...editAccountantForm, email: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                required
              />
              <input
                type="password"
                placeholder="New Password (optional)"
                value={editAccountantForm.password || ""}
                onChange={(e) => setEditAccountantForm({ ...editAccountantForm, password: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>
            <button
              type="submit"
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
            >
              Save Changes
            </button>
            <button
              type="button"
              onClick={() => setEditAccountantForm(null)}
              className="ml-2 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Accountants List Section */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Accountants</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="p-2 text-left text-gray-700">Full Name</th>
                <th className="p-2 text-left text-gray-700">Email</th>
                <th className="p-2 text-left text-gray-700">User Type</th>
                <th className="p-2 text-left text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {accountants?.map((accountant) => (
                <tr key={accountant._id} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="p-2">{accountant.fullName}</td>
                  <td className="p-2">{accountant.email}</td>
                  <td className="p-2">{accountant.userType === "adminAccountant1" ? "Accountant 1" : "Accountant 2"}</td>
                  <td className="p-2">
                    <button
                      onClick={() =>
                        setEditAccountantForm({
                          _id: accountant._id,
                          fullName: accountant.fullName,
                          email: accountant.email,
                          password: "",
                        })
                      }
                      className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 mr-2"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteAccountant(accountant._id)}
                      className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {accountants?.length === 0 && <p className="text-gray-600 mt-2">No accountants found.</p>}
        </div>
      </div>

      {/* Benefits Approval Section */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Benefit Approvals</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="p-2 text-left text-gray-700">Employee</th>
                <th className="p-2 text-left text-gray-700">Benefit Type</th>
                <th className="p-2 text-left text-gray-700">Amount (₦)</th>
                <th className="p-2 text-left text-gray-700">Period</th>
                <th className="p-2 text-left text-gray-700">Accountant 1</th>
                <th className="p-2 text-left text-gray-700">Accountant 2</th>
                <th className="p-2 text-left text-gray-700">Final Status</th>
                <th className="p-2 text-left text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {employeeBenefits?.flatMap((employee) =>
                employee.benefits.map((benefit) => (
                  <tr key={benefit._id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="p-2">{employee.firstName} {employee.lastName} ({employee.email})</td>
                    <td className="p-2 capitalize">{benefit.benefitType}</td>
                    <td className="p-2">{parseFloat(benefit.amountRequested).toLocaleString()}</td>
                    <td className="p-2">{benefit.benefitDescription.split(" for ")[1] || "N/A"}</td>
                    <td className="p-2">
                      {benefit.accountant1Status ? (
                        <div>
                          <span
                            className={
                              benefit.accountant1Status.status === "Approved" ? "text-green-600" : "text-red-600"
                            }
                          >
                            {benefit.accountant1Status.status}
                          </span>
                          <p className="text-sm text-gray-600">Reason: {benefit.accountant1Status.reason}</p>
                        </div>
                      ) : (
                        "Pending"
                      )}
                    </td>
                    <td className="p-2">
                      {benefit.accountant2Status ? (
                        <div>
                          <span
                            className={
                              benefit.accountant2Status.status === "Approved" ? "text-green-600" : "text-red-600"
                            }
                          >
                            {benefit.accountant2Status.status}
                          </span>
                          <p className="text-sm text-gray-600">Reason: {benefit.accountant2Status.reason}</p>
                        </div>
                      ) : (
                        "Pending"
                      )}
                    </td>
                    <td className="p-2">
                      {benefit.finalStatus ? (
                        <div>
                          <span
                            className={
                              benefit.finalStatus.status === "Approved" ? "text-green-600" : "text-red-600"
                            }
                          >
                            {benefit.finalStatus.status}
                          </span>
                          <p className="text-sm text-gray-600">Reason: {benefit.finalStatus.reason}</p>
                        </div>
                      ) : (
                        "Pending"
                      )}
                    </td>
                    <td className="p-2">
                      {benefit.accountant2Status?.status === "Approved" && !benefit.finalStatus && (
                        <div className="flex gap-2">
                          <input
                            type="text"
                            placeholder="Reason"
                            onChange={(e) => (benefit.reason = e.target.value)}
                            className="p-1 border border-gray-300 rounded mr-2"
                          />
                          <button
                            onClick={() => handleFinalBenefitAction(benefit._id, "Approved", benefit.reason)}
                            className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => handleFinalBenefitAction(benefit._id, "Declined", benefit.reason)}
                            className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                          >
                            Decline
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
              {employeeBenefits?.length === 0 && (
                <tr>
                  <td colSpan="8" className="p-2 text-gray-600 text-center">
                    No benefits found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Create Admin Section */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Create Admin Account</h3>
        <form onSubmit={handleCreateAdmin} className="bg-gray-100 p-6 rounded-lg shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <input
              type="text"
              placeholder="Full Name"
              value={adminFormData.fullName}
              onChange={(e) => setAdminFormData({ ...adminFormData, fullName: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={adminFormData.email}
              onChange={(e) => setAdminFormData({ ...adminFormData, email: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={adminFormData.password}
              onChange={(e) => setAdminFormData({ ...adminFormData, password: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>
          <button
            type="submit"
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
          >
            Create Admin
          </button>
          {success && <p className="mt-2 text-green-600">{success}</p>}
          {error && <p className="mt-2 text-red-600">{error}</p>}
        </form>
      </div>

      {/* Reassign JobSeeker Section */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Reassign JobSeeker</h3>
        <form onSubmit={handleReassignJobSeeker} className="bg-gray-100 p-6 rounded-lg shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <select
              value={reassignForm.jobSeekerId}
              onChange={(e) => setReassignForm({ ...reassignForm, jobSeekerId: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            >
              <option value="">Select JobSeeker</option>
              {activities.jobSeekers.map((js) => (
                <option key={js._id} value={js._id}>
                  {js.firstName} {js.lastName} ({js.email})
                </option>
              ))}
            </select>
            <select
              value={reassignForm.newAdminId}
              onChange={(e) => setReassignForm({ ...reassignForm, newAdminId: e.target.value })}
              className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            >
              <option value="">Select New Admin</option>
              {admins.map((admin) => (
                <option key={admin._id} value={admin._id}>
                  {admin.fullName} ({admin.email})
                </option>
              ))}
            </select>
          </div>
          <button
            type="submit"
            className="bg-green500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
          >
            Reassign
          </button>
        </form>
      </div>

      {/* Admins List Section */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Created Admins</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="p-2 text-left text-gray-700">Full Name</th>
                <th className="p-2 text-left text-gray-700">Email</th>
                <th className="p-2 text-left text-gray-700">Password</th>
                <th className="p-2 text-left text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {admins?.map((admin) => (
                <tr key={admin._id} className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="p-2">{admin.fullName}</td>
                  <td className="p-2">{admin.email}</td>
                  <td className="p-2 font-mono text-sm break-all">{admin.password}</td>
                  <td className="p-2">
                    <button
                      onClick={() => fetchAdminMetrics(admin._id)}
                      className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 mr-2"
                    >
                      View Metrics
                    </button>
                    <button
                      onClick={() => handleDeleteAdmin(admin._id)}
                      className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {admins?.length === 0 && <p className="text-gray-600 mt-2">No admins found.</p>}
        </div>
      </div>

      {/* Edit JobSeeker Section */}
      {editJobSeekerForm && (
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Edit JobSeeker</h3>
          <form onSubmit={handleEditJobSeeker} className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <input
                type="text"
                placeholder="First Name"
                value={editJobSeekerForm.firstName}
                onChange={(e) => setEditJobSeekerForm({ ...editJobSeekerForm, firstName: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                required
              />
              <input
                type="text"
                placeholder="Last Name"
                value={editJobSeekerForm.lastName}
                onChange={(e) => setEditJobSeekerForm({ ...editJobSeekerForm, lastName: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={editJobSeekerForm.email}
                onChange={(e) => setEditJobSeekerForm({ ...editJobSeekerForm, email: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
                required
              />
            </div>
            <button
              type="submit"
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
            >
              Save Changes
            </button>
            <button
              type="button"
              onClick={() => setEditJobSeekerForm(null)}
              className="ml-2 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Edit Search History Section */}
      {editSearchHistoryForm && (
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Edit Search History</h3>
          <form onSubmit={handleEditSearchHistory} className="bg-gray-100 p-6 rounded-lg shadow-md">
            <div className="mb-4">
              <input
                type="text"
                placeholder="Reason"
                value={editSearchHistoryForm.reason || ""}
                onChange={(e) => setEditSearchHistoryForm({ ...editSearchHistoryForm, reason: e.target.value })}
                className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500 w-full"
              />
            </div>
            <button
              type="submit"
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
            >
              Save Changes
            </button>
            <button
              type="button"
              onClick={() => setEditSearchHistoryForm(null)}
              className="ml-2 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Admin Activities Section */}
      <div>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Admin Activities</h2>

        <SuperAdminSearchHistory />

        {/* JobSeekers Table */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">JobSeekers Created</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="p-2 text-left text-gray-700">Name</th>
                  <th className="p-2 text-left text-gray-700">Email</th>
                  <th className="p-2 text-left text-gray-700">Created By</th>
                  <th className="p-2 text-left text-gray-700">Jobs Assigned</th>
                  <th className="p-2 text-left text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody>
                {activities.jobSeekers?.map((jobSeeker) => (
                  <tr key={jobSeeker._id} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="p-2">{jobSeeker.firstName} {jobSeeker.lastName}</td>
                    <td className="p-2">{jobSeeker.email}</td>
                    <td className="p-2">{jobSeeker.createdBy?.fullName} ({jobSeeker.createdBy?.email})</td>
                    <td className="p-2">{jobSeeker.jobAssignments?.length || 0}</td>
                    <td className="p-2">
                      <button
                        onClick={() =>
                          setEditJobSeekerForm({
                            _id: jobSeeker._id,
                            firstName: jobSeeker.firstName,
                            lastName: jobSeeker.lastName,
                            email: jobSeeker.email,
                          })
                        }
                        className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {activities.jobSeekers?.length === 0 && <p className="text-gray-600 mt-2">No jobseekers found.</p>}
          </div>
        </div>

        {/* Attendance Stats Table */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">JobSeeker Attendance Stats</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="p-2 text-left text-gray-700">Name</th>
                  <th className="p-2 text-left text-gray-700">Email</th>
                  <th className="p-2 text-left text-gray-700">Admin</th>
                  <th className="p-2 text-left text-gray-700">Present</th>
                  <th className="p-2 text-left text-gray-700">Absent</th>
                </tr>
              </thead>
              <tbody>
                {attendanceStats.map((stat) => (
                  <tr key={stat.jobSeekerId} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="p-2">{stat.firstName} {stat.lastName}</td>
                    <td className="p-2">{stat.email}</td>
                    <td className="p-2">{stat.admin ? `${stat.admin.fullName} (${stat.admin.email})` : "Unassigned"}</td>
                    <td className="p-2">{stat.attendance.present}</td>
                    <td className="p-2">{stat.attendance.absent}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {attendanceStats.length === 0 && <p className="text-gray-600 mt-2">No attendance stats available.</p>}
          </div>
        </div>

        {/* Admin Metrics Section */}
        {adminMetrics && (
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Admin Activity Metrics</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2">JobSeekers Attended</h4>
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="p-2 text-left text-gray-700">Period</th>
                      <th className="p-2 text-left text-gray-700">Count</th>
                      <th className="p-2 text-left text-gray-700">JobSeekers</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-200 hover:bg-gray-50">
                      <td className="p-2">Daily</td>
                      <td className="p-2">{adminMetrics.daily.count}</td>
                      <td className="p-2">{adminMetrics.daily.jobSeekers.map((js) => js.email).join(", ") || "None"}</td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50">
                      <td className="p-2">Weekly</td>
                      <td className="p-2">{adminMetrics.weekly.count}</td>
                      <td className="p-2">{adminMetrics.weekly.jobSeekers.map((js) => js.email).join(", ") || "None"}</td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50">
                      <td className="p-2">Monthly</td>
                      <td className="p-2">{adminMetrics.monthly.count}</td>
                      <td className="p-2">{adminMetrics.monthly.jobSeekers.map((js) => js.email).join(", ") || "None"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="flex justify-center">
                <div className="w-full max-w-xs">
                  <Pie data={pieChartData} options={{ responsive: true, maintainAspectRatio: false }} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Per-Admin JobSeeker Attendance Stats Section */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Per-Admin JobSeeker Attendance Stats</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Attendance Breakdown by Admin</h4>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="p-2 text-left text-gray-700">Admin</th>
                      <th className="p-2 text-left text-gray-700">Daily Count</th>
                      <th className="p-2 text-left text-gray-700">Weekly Count</th>
                      <th className="p-2 text-left text-gray-700">Monthly Count</th>
                      <th className="p-2 text-left text-gray-700">JobSeekers (Daily)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminJobSeekerStats.length > 0 ? (
                      adminJobSeekerStats.map((stat) => (
                        <tr key={stat.admin._id} className="border-b border-gray-200 hover:bg-gray-50">
                          <td className="p-2">{stat.admin.fullName} ({stat.admin.email})</td>
                          <td className="p-2">{stat.daily.count}</td>
                          <td className="p-2">{stat.weekly.count}</td>
                          <td className="p-2">{stat.monthly.count}</td>
                          <td className="p-2">{stat.daily.jobSeekers.map((js) => js.email).join(", ") || "None"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="p-2 text-gray-600 text-center">
                          No admin jobseeker attendance stats available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="w-full max-w-xs">
                <h4 className="text-lg font-semibold text-gray-800 mb-2 text-center">Total JobSeekers Attended</h4>
                {totalJobSeekerPieChartData ? (
                  <Pie data={totalJobSeekerPieChartData} options={{ responsive: true, maintainAspectRatio: false }} />
                ) : (
                  <p className="text-gray-600 text-center">No data available for pie chart.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminManage;



































